export const FormFields = {
  phoneNumber: 'phoneNumber',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  zip: 'zip',
  dateOfBirth: 'dateOfBirth',
  password: 'password',
  reEnterPassword: 'reEnterPassword',
  email: 'email',
  emailConfirm: 'emailConfirm',
}

export const dateFormat = {
  dob: 'MM/DD/YYYY',
}

export const ppfDateFormat = {
  dob: 'YYYY-MM-DD',
}

export const placeholder = {
  dob: '1992/01/01',
}

export const capitalizeFirstLetter = string => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
}

export const capitalizeFirstLetterEachWord = string => {
  return string
    .trim()
    .toLowerCase()
    .split(' ')
    .map(capitalizeFirstLetter)
    .join(' ')
}
